import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const ArrowNoStemSmall = ({ color = 'black', direction = 'down', size = 'sm', translateX = 0, translateY = 0, strokeWidth = 2, ...attr }) => {
  const rotations = {
    up: '180',
    down: '0',
    left: '90',
    right: '-90',
  };
  const _rotation = rotations[direction] ?? '0';

  return (
    <svg
      {...iconSizes[size]}
      fill="none"
      transform={`rotate(${_rotation}) translate(${translateX}, ${translateY})`}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...attr}
    >
      <path d="M4 6L8 10L12 6" stroke={color} strokeWidth={strokeWidth} />
    </svg>
  );

};

export default ArrowNoStemSmall;
